'use client'
import styles from '@/app/styles/components/pages/cart/process-bar.module.scss'
import {FormattedMessage} from "react-intl";
import CartProcessStep from "@/app/constants/CartProcessStep";
import {useState} from "react";

const ProcessBar = ({step = CartProcessStep.CART, changeStep}) => {

    const handleChangeStep = (step) => {
        if(changeStep) {
            changeStep(step)
        }
    }

    return <div className={styles.processBarContainer}>
        <div className={step >= CartProcessStep.CART ? styles.processBarItemCartActive : styles.processBarItemCart}>
            <FormattedMessage id={'components.pages.cart.progressBar.cart'}/>
            {
                step >= CartProcessStep.CART &&
                <div className={styles.arrowCart}/>
            }
        </div>
        <div
            className={step >= CartProcessStep.DELIVERY ? styles.processBarItemDeliveryActive : styles.processBarItemDelivery}>
            <FormattedMessage id={'components.pages.cart.progressBar.deliveryDetails'}/>

            {
                step >= CartProcessStep.DELIVERY &&
                <div className={styles.arrowDelivery}/>
            }
        </div>
        <div
            className={step >= CartProcessStep.SENDER ? styles.processBarItemSenderActive : styles.processBarItemSender}>
            <FormattedMessage id={'components.pages.cart.progressBar.giftSender'}/>
            {
                step >= CartProcessStep.SENDER &&
                <div className={styles.arrowSender}/>
            }
        </div>
        <div
            className={step >= CartProcessStep.PAYMENT ? styles.processBarItemPaymentActive : styles.processBarItemPayment}>
            <FormattedMessage id={'components.pages.cart.progressBar.payment'}/>
        </div>
    </div>
}

export default ProcessBar